import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { DepartmentsRoutes } from "./departments.routes";
import { DepartmentListComponent } from "./department-list/department-list.component";
import { DepartmentFormComponent } from "./department-form/department-form.component";
import { DepartmentPersonFormComponent } from "./department-person-form/department-person-form.component";
import { DepartmentService, DepartmentFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    DepartmentsRoutes,
  ],
  declarations: [
    DepartmentListComponent,
    DepartmentFormComponent,
    DepartmentPersonFormComponent,
  ],
  providers: [DepartmentService, DepartmentFormService],
})
export class DepartmentsModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/departments.module.ts